
import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: 'María González',
      role: 'Empresaria',
      text: 'Gracias al Método FEP de Leo García, pude proteger mi negocio y mi familia al mismo tiempo. Ahora tengo tranquilidad sabiendo que estamos cubiertos ante cualquier imprevisto.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Carlos Ramírez',
      role: 'Ingeniero',
      text: 'Después de años ahorrando sin un plan claro, Leo me ayudó a estructurar mis finanzas de manera inteligente. El Método FEP hizo crecer mis ahorros y protegió mi patrimonio.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Ana Martínez',
      role: 'Doctora',
      text: 'Como médica, entiendo la importancia de la prevención. Leo aplicó ese mismo concepto a mis finanzas. Su enfoque educativo me permitió entender cada decisión.',
      rating: 5,
    },
  ];

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-gray-500 text-sm uppercase tracking-wider">
            Testimonios
          </span>
          <h2 className="text-3xl font-bold text-[#1a2332] mt-3">
            Lo Que Dicen Mis Clientes
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-[#faf8f3] rounded-2xl p-6 flex flex-col justify-between"
            >
              <div>
                <div className="flex gap-0.5 mb-4">
                  {[...Array(t.rating)].map((_, i) => (
                    <i
                      key={i}
                      className="ri-star-fill text-lg text-[#ffd166]"
                      aria-hidden="true"
                    ></i>
                  ))}
                </div>
                <p className="text-[#1a2332] text-sm leading-relaxed mb-6">
                  &ldquo;{t.text}&rdquo;
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#1a2332] flex items-center justify-center text-white font-semibold text-sm">
                  {t.name
                    .split(' ')
                    .map((n) => n[0])
                    .join('')}
                </div>
                <div>
                  <p className="text-[#1a2332] text-sm font-semibold">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          <div className="text-center p-6 bg-[#faf8f3] rounded-2xl">
            <div className="text-3xl font-bold text-[#2d5a8f] mb-1">200+</div>
            <p className="text-gray-600 text-sm">Clientes Satisfechos</p>
          </div>
          <div className="text-center p-6 bg-[#faf8f3] rounded-2xl">
            <div className="text-3xl font-bold text-[#2d5a8f] mb-1">4.9/5</div>
            <p className="text-gray-600 text-sm">Calificación Promedio</p>
          </div>
          <div className="text-center p-6 bg-[#faf8f3] rounded-2xl">
            <div className="text-3xl font-bold text-[#2d5a8f] mb-1">98%</div>
            <p className="text-gray-600 text-sm">Nos Recomiendan</p>
          </div>
        </div>
      </div>
    </section>
  );
}
